import { Record } from '@common/data-models/records/record';
import { SingleViewStateRecord } from '@common/data-models/records/single-viewstate-record';
import { ObjectTypes } from "@common/enums/object-types";
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { ViewStateOptions } from '../navigation/viewstate-options';
import { PSTFieldNames } from '../fields/pst-field-names';
import { ViewStateOptionsSerializer } from '../serializers/serializers';

export class AssignmentViewStateRecord extends SingleViewStateRecord {
    
    public initialize(){
        this.viewStateType = ViewStateTypes.ASSIGNMENT;
        super.initialize();
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateLayout(): ViewStateOptions { return this.getAs<ViewStateOptions>("PSTViewStateLayout"); }
    public set viewStateLayout(value: ViewStateOptions) { this.set("PSTViewStateLayout", value); }

    public get assignmentGuid(): string { return this.getAs<string>("assignmentGuid"); }
    public set assignmentGuid(value: string) { this.set("assignmentGuid", value); }
}
